import {useListView} from '../../core/ListViewProvider'
import {OperatorsListToolbar} from './OperatorsListToolbar'
import {OperatorsListGrouping} from './OperatorsListGrouping'
import {OperatorsSearchComponent} from './OperatorsSearchComponent'
import {TOKENS} from '../../../../../../components/design-system'

type PropTypes = {
  showAddOperator?: boolean
}

const OperatorsListHeader = ({showAddOperator = true}: PropTypes) => {
  const {selected} = useListView()
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: TOKENS.spacing.md,
        padding: '14px 18px',
        borderBottom: `1px solid ${TOKENS.color.border}`,
        background: TOKENS.color.card,
      }}
    >
      <OperatorsSearchComponent />
      <div>
        {selected.length > 0 ? <OperatorsListGrouping /> : <OperatorsListToolbar showAddOperator={showAddOperator} />}
      </div>
    </div>
  )
}

export {OperatorsListHeader}
